module.exports = __webpack_public_path__ + "static/media/Trade Gothic B-01.2bb6589f.svg";